export default function HeroSection() {
  const scrollToNext = () => {
    const el = document.getElementById('background');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/d58fd1c538f6e15199cd24578790c300.jpg"
          alt="雨の東京、跳び立つ少女"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10">
        <p
          className="font-sans text-white/60 text-xs tracking-[0.35em] uppercase mb-8 opacity-0 animate-fade-in"
          style={{ animationDelay: '0.3s', animationFillMode: 'forwards' }}
        >
          Chammi Inc. &nbsp;|&nbsp; Recruit 2026
        </p>

        <h1
          className="font-serif text-white text-3xl md:text-5xl lg:text-6xl leading-relaxed md:leading-relaxed tracking-wide mb-6 opacity-0 animate-fade-up"
          style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}
        >
          日本の創作文化を<br />
          世界へ届ける<br />
          その拠点を、高知に
        </h1>

        <p
          className="font-sans text-white/75 text-sm md:text-base tracking-wider mb-12 opacity-0 animate-fade-up"
          style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}
        >
          AIアニメ制作スタジオ　マネージャー　募集
        </p>

        <div
          className="opacity-0 animate-fade-up"
          style={{ animationDelay: '1.1s', animationFillMode: 'forwards' }}
        >
          <button
            onClick={() => {
              const el = document.getElementById('apply');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap cursor-pointer font-sans text-xs tracking-[0.25em] bg-terracotta text-white px-10 py-4 rounded-full hover:bg-terracotta-light transition-colors duration-300"
          >
            募集要項を読む
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 cursor-pointer flex flex-col items-center gap-2 opacity-0 animate-fade-in"
        style={{ animationDelay: '1.5s', animationFillMode: 'forwards' }}
        aria-label="スクロール"
      >
        <span className="font-sans text-white/50 text-[10px] tracking-[0.3em]">SCROLL</span>
        <div className="w-px h-10 bg-white/30 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full bg-white/70 animate-[scrollLine_1.8s_ease-in-out_infinite]" style={{ height: '40%' }} />
        </div>
      </button>
    </section>
  );
}
